import { render, staticRenderFns } from "./VCard.vue?vue&type=template&id=b0b7860c&"
import script from "./VCard.vue?vue&type=script&lang=js&"
export * from "./VCard.vue?vue&type=script&lang=js&"
import style0 from "./VCard.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports